import { __spreadArray } from "tslib";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import { useBiClickLogger } from '@wix/da-bi/pkg/hooks/useBiClickLogger';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import LoadingIndicator from '../../../LoadingIndicator';
import StreamedList from '../../../StreamedList';
import { FolderType } from '../../redux/types';
import GallectionListItem from '../../../GallectionListItem';
import s from './FolderList.scss';
var FolderList = function (_a) {
    var submissionType = _a.submissionType, folders = _a.folders, isFetching = _a.isFetching, streamId = _a.streamId, hasOnlyOneChunkOfGroupFoldersToLoad = _a.hasOnlyOneChunkOfGroupFoldersToLoad, onFolderSelected = _a.onFolderSelected;
    var t = useTranslation().t;
    var _b = useState(''), filterValue = _b[0], setFilterValue = _b[1];
    var hasNoFolders = !isFetching && !folders.length;
    var _c = useState([]), justAddedToFolderIds = _c[0], setAddedToFolderIds = _c[1];
    var onGallectionListItemChange = function (_a) {
        var folderId = _a.folderId, isSelected = _a.isSelected;
        if (isSelected) {
            onFolderSelected(folderId);
            setAddedToFolderIds(__spreadArray(__spreadArray([], justAddedToFolderIds, true), [folderId], false));
        }
    };
    var setInputRef = useBiClickLogger(BiData({
        evid: 2,
        click_info: submissionType === FolderType.Collection
            ? 'addToGroup.searchCollection'
            : 'addToGroup.searchGallery',
        sectionname: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
    })).setTrackingRef;
    return (React.createElement(React.Fragment, null,
        hasOnlyOneChunkOfGroupFoldersToLoad && (React.createElement(TextInput, { id: "add-to-group-filter-input", ref: setInputRef, value: filterValue, className: s['filter-input'], onChange: function (ev) { return setFilterValue(ev.target.value); }, placeholder: t('addToGroupPopup.input.filter.placeholder'), prefix: React.createElement(SearchIcon, null), label: t('addToGroupPopup.input.filter.placeholder'), isLabelHidden: true })),
        React.createElement(StreamedList, { streamId: streamId, className: s['list'], wrapperClassName: s['scrollable'] },
            folders.map(function (_a) {
                var folder = _a.folder, added = _a.added, suggested = _a.suggested;
                if (!folder ||
                    (filterValue &&
                        !folder.name.toLowerCase().includes(filterValue.toLowerCase()))) {
                    return null;
                }
                var renderSuffix = function () {
                    var buttonI18nKey = 'addToGroupPopup.button.add';
                    if (added) {
                        buttonI18nKey = 'addToGroupPopup.button.added';
                    }
                    if (suggested) {
                        buttonI18nKey = 'addToGroupPopup.button.suggested';
                    }
                    return (React.createElement(TextButton, { size: "small", variant: "approval-green", disabled: added || suggested }, t(buttonI18nKey)));
                };
                return (React.createElement(GallectionListItem, { key: folder.folderId, isSelected: added ||
                        suggested ||
                        justAddedToFolderIds.includes(folder.folderId), isDisabled: added || suggested, gallection: folder, showSuffixOnlyOnHover: !added && !suggested, suffix: renderSuffix(), onChange: onGallectionListItemChange }));
            }),
            hasNoFolders && (React.createElement("div", { className: s['empty'] }, t("addToGroup.noFolders.".concat(submissionType))))),
        isFetching && React.createElement(LoadingIndicator, { view: "llama", className: s['loader'] })));
};
FolderList.displayName = 'FolderList';
export default FolderList;
//# sourceMappingURL=FolderList.js.map